import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import styled from 'styled-components';
import { Header, Message } from 'semantic-ui-react';

import { USER_CONFIG, BATCHES_CONFIG } from 'constants/api';
import { STUDENT_PER_PAGE } from 'constants/list';
import { HeaderHead } from 'modules/form';
import StudentListForm from 'screens/batch-assignment/student-form/student-list-form';
import StudentDemoProfile from 'screens/batch-assignment/student-form/studentDemoProfile';

import { get as getConfig } from 'actions/configs';
import { get as getStudent } from 'actions/students';
import { getAll as getPrograms } from 'actions/programs';
import { getAll as getStudentDemoList } from 'actions/student-demo-list';

const HeaderHeadWrapper = styled(HeaderHead)`
  padding: 10px 10px 0px 10px;
`;

const programQueryParam = {
  is_live: true,
};

class StudentFormParent extends PureComponent {
  static defaultProps = {
    userConfig: {},
    batchConfig: {},
    programs: [],
    students: null,
    studentDemoList: null,
    toggledRMGKData: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      errorText: null,
      studentProfileInfo: null,
    };
  }

  static getDerivedStateFromProps(props, state) {
    const newState = {};
    const { students, actions, studentDemoList } = props;
    const { studentId } = props.match.params;

    const listParams = {
      page: 1,
      per_page: STUDENT_PER_PAGE,
      student_id: studentId,
      action: 'get',
      include_recent_class_id: true,
    };

    const studentGet = store.get(students, studentId);
    const demoGet = store.getAll(studentDemoList, listParams);

    if (studentGet && studentGet.isLoaded && !studentGet.isStale) {
      if (studentGet.data && Object.keys(studentGet.data).length) {
        newState.studentProfileInfo = studentGet.data;
      } else {
        newState.errorText = 'Student With this id does not exist';
      }
    } else if (studentGet && studentGet.isStale) actions.getStudent(studentId);

    if (demoGet && demoGet.isLoaded && newState.studentProfileInfo) {
      newState.studentProfileInfo = {
        ...newState.studentProfileInfo,
        demos: demoGet.data,
      };
    }

    return newState;
  }

  componentDidMount() {
    const { actions, programs } = this.props;
    const { studentId } = this.props.match.params;
    const { student } = this.state;

    const listParams = {
      page: 1,
      per_page: STUDENT_PER_PAGE,
      student_id: studentId,
      action: 'get',
      include_recent_class_id: true,
    };
    const filterData = {
      page: 1,
      per_page: STUDENT_PER_PAGE,
      student_id: studentId,
      action: 'get',
      include_recent_class_id: true,
    };

    actions.getConfig(USER_CONFIG);
    actions.getConfig(BATCHES_CONFIG);
    actions.getStudentDemoList(listParams, filterData);

    if (!programs.length) actions.getPrograms(programQueryParam);
    if (!student && studentId) actions.getStudent(studentId);
  }

  render() {
    const { userConfig, batchConfig, programs } = this.props;
    const { studentProfileInfo, errorText } = this.state;
    const studentId =
      studentProfileInfo && studentProfileInfo.id ? studentProfileInfo.id : null;

    const configReady = !!(
      userConfig &&
      Object.keys(userConfig).length &&
      batchConfig &&
      Object.keys(batchConfig).length
    );
    const studentProfileReady = !!(
      studentProfileInfo &&
      studentProfileInfo.demos &&
      programs
    );

    const isReady = configReady && studentProfileReady;

    return (
      <>
        {errorText && (
          <Message negative>
            <p>{errorText}</p>
          </Message>
        )}
        {isReady && (
          <>
            <StudentDemoProfile
              {...this.state}
              userConfig={userConfig}
              batchConfig={batchConfig}
              programs={programs}
              student={studentProfileInfo}
            />

            <HeaderHeadWrapper>
              <Header as="h3">Student Demo Slot Details</Header>
            </HeaderHeadWrapper>
            {
              <StudentListForm
                studentId={studentId}
                {...this.state}
                programs={programs}
              />
            }
          </>
        )}
      </>
    );
  }
}

export default connect(
  ({ configs, programs, students, studentDemoList }) => ({
    userConfig: store.get(configs, USER_CONFIG)
      ? store.get(configs, USER_CONFIG).data
      : null,
    batchConfig: store.get(configs, BATCHES_CONFIG)
      ? store.get(configs, BATCHES_CONFIG).data
      : null,
    programs: store.getAll(programs, programQueryParam)
      ? store.getAll(programs, programQueryParam).data
      : null,
    students,
    studentDemoList,
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        getConfig,
        getStudentDemoList,
        getPrograms,
        getStudent,
      },
      dispatch,
    ),
  }),
)(StudentFormParent);
